/* eslint-disable */

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Api from "./Api";
import PARSE from "html-react-parser";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ApiNew from "./Api";

const api = new ApiNew();

export default function SSoft_FAQ() {
  const activeLanguage = useSelector((state) => state.content.activeLanguage);
  const [sections, setSections] = useState([]);
  const [title, setTitle] = useState(null);
  const [listLine, setListLine] = useState([]);
  const [loaded, setLoaded] = useState(false);

  // track which accordion index is expanded; false means none
  const [expanded, setExpanded] = useState(0); // keep first open by default

  useEffect(() => {
    const getSectionDetail = () => {
      api
        .getSectionDetail({ language: activeLanguage })
        .then((res) => {
          if (res === 200 || res.data) {
            setSections(res.data.results);
          }
        })
        .catch((err) => {
          console.log("~ err", err);
        });
    };

    getSectionDetail();
  }, [activeLanguage]);

  useEffect(() => {
    let switchCaseCompleted = 0;

    if (sections.length > 0) {
      const sec = sections[0]?.widgets;
      if (sec && sec.length !== 0) {
        sec.forEach((section, i) => {
          switch (i) {
            case 0: {
              setTitle(section?.widget_contents[0]);
              break;
            }
            case 1: {
              setListLine(section?.widget_contents);
              break;
            }
            default:
              break;
          }

          switchCaseCompleted++;
        });

        if (switchCaseCompleted === 2) {
          setLoaded(true);
        }
      }
    }
  }, [sections]);

  return loaded ? (
    <div className="section-container section-margin-x relative pt-[20px] md:pt-[149px] bg-white mb-[70px]">
      <div className="max-w-[760px] mx-auto  sm:px-6 lg:px-8">
        {/* Section Title */}
        <h1 className="header-style-non-hero text-center mb-4">
          {title?.article_language?.title}
        </h1>
        <p className="subheader-style-non-hero mb-12 max-w-3xl mx-auto">
          {PARSE(title?.article_language?.content || "")}
        </p>

        {/* MUI Accordions - Match Mockup Style */}
        <div className="space-y-3">
          {listLine?.map((line, index) => {
            const { article_language } = line;
            const isExpanded = expanded === index;

            return (
              <Accordion
                key={index}
                expanded={isExpanded}
                onChange={(_, isNowExpanded) =>
                  setExpanded(isNowExpanded ? index : false)
                }
                sx={{
                  borderRadius: "8px !important",
                  border: "none !important",
                  borderBottom: "1px solid #e5e7eb",
                  boxShadow: "none !important",
                  "&:hover": {
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  },
                  "&.Mui-expanded": {
                    margin: 0,
                    border: "1px solid #1f2937 !important",
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={
                    isExpanded ? (
                      <RemoveIcon
                        sx={{
                          color: "#1f2937",
                          fontSize: "1.25rem",
                        }}
                      />
                    ) : (
                      <AddIcon
                        sx={{
                          color: "#1f2937",
                          fontSize: "1.25rem",
                        }}
                      />
                    )
                  }
                  sx={{
                    "& .MuiAccordionSummary-content": {
                      margin: "12px 0",
                    },
                    "& .MuiTypography-root": {
                      fontWeight: 600,
                      fontSize: "1.25rem",
                      color: "#1f2937",
                    },
                  }}
                >
                  <p className="content-header-style-non-hero mdl:!text-[18px] text-[17px]">
                    {article_language?.title}
                  </p>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    paddingTop: 0,
                    paddingBottom: "16px",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                  }}
                >
                  <p className="content-subheader-style-non-hero">
                    {PARSE(article_language?.content || "")}
                  </p>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </div>
      </div>
    </div>
  ) : (
    <div className="section-container section-margin-x">
      <Skeleton
        width={"100%"}
        className=" lg:h-[373px] s:h-[600px] h-[700px]"
      />
    </div>
  );
}
